"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEVERAGEABLE_ASSETS_SELECT_OPTIONS = exports.LEVERAGEABLE_ASSETS = exports.REQUIRED_INSIGHTS_SELECT_OPTIONS = exports.REQUIRED_INSIGHTS = exports.RequiredInsights = exports.SYNDICATION_INVESTOR_INVESTMENT_RANGE_OPTIONS = exports.SYNDICATION_INVESTOR_INVESTMENT_TYPE_OPTIONS = void 0;
const legacy_ui_1 = require("@hum/legacy-ui");
const enums_1 = require("../Syndication/enums");
const financials_1 = require("../Constants/financials");
exports.SYNDICATION_INVESTOR_INVESTMENT_TYPE_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)({
    [enums_1.SyndicationInvestmentTypes.Angel]: 'Angel',
    [enums_1.SyndicationInvestmentTypes.GrowthEquity]: 'Growth Equity',
    [enums_1.SyndicationInvestmentTypes.LeveragedBuyOut]: 'Leveraged Buyout (LBO)',
    [enums_1.SyndicationInvestmentTypes.MezzDebt]: 'Mezz Debt',
    [enums_1.SyndicationInvestmentTypes.PreIpo]: 'Pre IPO',
    [enums_1.SyndicationInvestmentTypes.Seed]: 'Seed',
    [enums_1.SyndicationInvestmentTypes.SeniorBankDebt]: 'Senior Bank Debt',
    [enums_1.SyndicationInvestmentTypes.SeriesA]: 'Series A',
    [enums_1.SyndicationInvestmentTypes.SeriesBPlus]: 'Series B or later',
    [enums_1.SyndicationInvestmentTypes.SpecialSituations]: 'Special Situations',
    [enums_1.SyndicationInvestmentTypes.VentureDebt]: 'Venture Debt',
    [enums_1.SyndicationInvestmentTypes.SmallCapPublic]: 'Small cap public',
    [enums_1.SyndicationInvestmentTypes.ReceivablesFinance]: 'Receivables Finance',
});
exports.SYNDICATION_INVESTOR_INVESTMENT_RANGE_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)({
    [enums_1.SyndicationInvestmentRanges.LessThan1M]: 'Less Than 1M',
    [enums_1.SyndicationInvestmentRanges.Between1And5M]: 'Between 1 and 5M',
    [enums_1.SyndicationInvestmentRanges.Between5And10M]: 'Between 5 and 10M',
    [enums_1.SyndicationInvestmentRanges.Between10And25M]: 'Between 10 and 25M',
    [enums_1.SyndicationInvestmentRanges.Between25And50M]: 'Between 25 and 50M',
    [enums_1.SyndicationInvestmentRanges.Between50And100M]: 'Between 50 and 100M',
    [enums_1.SyndicationInvestmentRanges.MoreThan100M]: 'More Than 100M',
});
var RequiredInsights;
(function (RequiredInsights) {
    RequiredInsights["RevenueBreakdownAndProjections"] = "revenue_breakdown_and_projections";
    RequiredInsights["CustomerCohortAcquisitionCostAndLtv"] = "customer_cohort_acquisition_cost_and_ltv";
    RequiredInsights["MarginProgression"] = "margin_progression";
    RequiredInsights["SalesAndMarketingSpendEfficiency"] = "sales_and_marketing_spend_efficiency";
    RequiredInsights["ScenarioBuilding"] = "scenario_building";
    RequiredInsights["PublicCompanyAndPrivatePeerComparables"] = "public_company_and_private_peer_comparables";
})(RequiredInsights = exports.RequiredInsights || (exports.RequiredInsights = {}));
exports.REQUIRED_INSIGHTS = {
    [RequiredInsights.RevenueBreakdownAndProjections]: 'Revenue breakdown and projections',
    [RequiredInsights.CustomerCohortAcquisitionCostAndLtv]: 'Customer cohort acquisition cost and ltv',
    [RequiredInsights.MarginProgression]: 'Margin progression',
    [RequiredInsights.SalesAndMarketingSpendEfficiency]: 'Sales and marketing spend efficiency',
    [RequiredInsights.ScenarioBuilding]: 'Scenario building',
    [RequiredInsights.PublicCompanyAndPrivatePeerComparables]: 'Public company and private peer comparables',
};
exports.REQUIRED_INSIGHTS_SELECT_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)(exports.REQUIRED_INSIGHTS);
exports.LEVERAGEABLE_ASSETS = {
    [financials_1.LeverageableAssets.NotApplicable]: 'N/A',
    [financials_1.LeverageableAssets.AccountsReceivable]: 'Accounts Receivable',
    [financials_1.LeverageableAssets.Inventory]: 'Inventory',
    [financials_1.LeverageableAssets.RealEstate]: 'Real Estate',
    [financials_1.LeverageableAssets.CapitalEquipment]: 'Capital Equipment',
};
exports.LEVERAGEABLE_ASSETS_SELECT_OPTIONS = (0, legacy_ui_1.selectOptionsFromMap)(exports.LEVERAGEABLE_ASSETS);
//# sourceMappingURL=Application.js.map